import Vue from 'vue'
import VueI18n from 'vue-i18n'
import deMessage from './de.json'
import enMessage from './en.json'
import frMessage from './fr.json'
import nlMessage from './nl.json'
import itMessage from './it.json'
import esMessage from './es.json'
import ptMessage from './pt.json'
import noMessage from './no.json'
import getBrowserLocale from "./get-browser-locale"
import { supportedLocalesInclude } from "./supported-locales"
import store from '../store'

Vue.use(VueI18n)


const messages = getSupportedLanguages()

function getSupportedLanguages() {
    const id = process.env.VUE_APP_APP_CUSTOM_ID;
    const languages = {};

    if (supportedLocalesInclude("en")) {
        const base = enMessage;
        let custom = {};
        try {
            custom = require(`./${id}/en.json`);
        } catch (e) {
            // fallback silently
        }
        languages.en = deepMerge(base, custom);
    }

    if (supportedLocalesInclude("de")) {
        const base = deMessage;
        let custom = {};
        try {
            custom = require(`./${id}/de.json`);
        } catch (e) {
            // fallback silently
        }
        languages.de = deepMerge(base, custom);
    }

    if (supportedLocalesInclude("fr")) {
        const base = frMessage;
        let custom = {};
        try {
            custom = require(`./${id}/fr.json`);
        } catch (e) {
            // fallback silently
        }
        languages.fr = deepMerge(base, custom);
    }
    if (supportedLocalesInclude("nl")) {
        const base = nlMessage;
        let custom = {};
        try {
            custom = require(`./${id}/nl.json`);
        } catch (e) {
            // fallback silently
        }
        languages.nl = deepMerge(base, custom);
    }
    if (supportedLocalesInclude("it")) {
        const base = itMessage;
        let custom = {};
        try {
            custom = require(`./${id}/it.json`);
        } catch (e) {
            // fallback silently
        }
        languages.it = deepMerge(base, custom);
    }
    if (supportedLocalesInclude("es")) {
        const base = esMessage;
        let custom = {};
        try {
            custom = require(`./${id}/es.json`);
        } catch (e) {
            // fallback silently
        }
        languages.es = deepMerge(base, custom);
    }
    if (supportedLocalesInclude("pt")) {
        const base = ptMessage;
        let custom = {};
        try {
            custom = require(`./${id}/pt.json`);
        } catch (e) {
            // fallback silently
        }
        languages.pt = deepMerge(base, custom);
    }
    if (supportedLocalesInclude("no")) {
        const base = noMessage;
        let custom = {};
        try {
            custom = require(`./${id}/no.json`);
        } catch (e) {
            // fallback silently
        }
        languages.no = deepMerge(base, custom);
    }

    return languages;
}

function deepMerge(base, override) {
    const result = { ...base };
    for (const key in override) {
        if (
            base[key] &&
            typeof base[key] === 'object' &&
            typeof override[key] === 'object'
        ) {
            result[key] = deepMerge(base[key], override[key]);
        } else {
            result[key] = override[key];
        }
    }
    return result;
}

function getCachedLanguage(){
  return (store && store.state && store.state.settings && store.state.settings.app_locale)?store.state.settings.app_locale:null;
}

function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true })
  if (supportedLocalesInclude(browserLocale)) {
    return browserLocale
  } else {
    return process.env.VUE_APP_LOCALE
  }
}

const i18n = new VueI18n({
  locale: getCachedLanguage() || getStartingLocale(),
  messages,
  fallbackLocale: process.env.VUE_APP_LOCALE,
  silentFallbackWarn: true
})

setTimeout(()=>{i18n.locale = getCachedLanguage() || getStartingLocale();}, 200)

export default i18n